import { ReactNode } from "react";
import { CurrentTripContextProvider } from "./currentTripContext/currentTripContext";
import { DataStreamingContextProvider } from "./dataStreamingContext/DataStreamingContext";
import { StateProvider } from "./globalContext/context";
import { HistoryContextProvider } from "./historyContext/historyContext";
import { RecommendedTripContextProvider } from "./recommendedTripContext/recommendedTripContext";
import { SocketContextProvider } from "./socketContext/SocketContext";
import { TopDestinationContextProvider } from "./topDestinationContext/TopDestinationContext";
import { ItineraryContextProvider } from "../component/itineraryDetails/itineraryDetailsPage/components/itineraryDetailsContext/ItineraryDetailsContext";
import IntentErrorBoundary from "../component/intentNudge/IntentErrorBoundary";
import IntentNudgeRenderer from "../component/intentNudge/IntentNudgeRenderer";
import PusherBootstrap from "../component/pusherBootstrap/PusherBootstrap";
import { PocContextProvider } from "./pocContext/pocContext";
import { VoiceModeProvider } from "./voiceModeContext/VoiceModeContext";
import { ExperimentProvider } from "../experiments";

export default function ContextProvider({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <ExperimentProvider>
    <StateProvider>
      <SocketContextProvider>
        <CurrentTripContextProvider>
          <HistoryContextProvider>
            <DataStreamingContextProvider>
              <ItineraryContextProvider>
                <TopDestinationContextProvider>
                  <RecommendedTripContextProvider>
                    <PocContextProvider>
                      <VoiceModeProvider>
                        {children}
                        <PusherBootstrap />
                        <IntentErrorBoundary>
                          <IntentNudgeRenderer />
                        </IntentErrorBoundary>
                      </VoiceModeProvider>
                    </PocContextProvider>
                  </RecommendedTripContextProvider>
                </TopDestinationContextProvider>
              </ItineraryContextProvider>
            </DataStreamingContextProvider>
          </HistoryContextProvider>
        </CurrentTripContextProvider>
      </SocketContextProvider>
    </StateProvider>
    </ExperimentProvider>
  );
}
